import type { MaterialFormData } from '#components/order/CreateOrderDialog/OrderFormValidation.ts';

export const parseCargoMaterial = ({
    packageType,
    loadingMeter,
    weight,
    name,
    quantity,
}: {
    packageType: string;
    quantity: number;
    name: string;
    weight?: number;
    loadingMeter?: number;
}): MaterialFormData | undefined => {
    return {
        type: 'cargo-material',
        packageType,
        quantity,
        name,
        loadingMeter: Number.isFinite(loadingMeter) ? loadingMeter : undefined,
        weight: Number.isFinite(weight) ? weight : undefined,
    };
};
